export class PluginDocumentationHelper {
  static createPluginDocKey(projectKey: string, pluginClassName: string): string {
    return projectKey + pluginClassName;
  }
}
